import React, { useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"
import toast from 'react-hot-toast'

export default function CreateUserOffers () {
    let [data, setData] = useState({
        name:"",
        pic:"",
        description:"",
        validdate:"",
        offerDiscount:"",
        offerEating:"",

    })
    let [getData,setGetData]= useState()
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
      name:"Name Field Is Required",
      pic:"Pic Field Is Required",
      description:"Descriptions Field Is Required",
      validdate:" Offer valid Date Field Is Required",
      offerDiscount:"Discount Offer Field  Is Required",
      offerEating:" Discount Offer2 Field Is Required",
    })
  const getInputData=(e)=>{
    let name= e.target.name;
    let value =e.target.files? e.target.files[0]:e.target.value;
    if(name ==="name" || name==="pic" || name==="profile" ||  name === "validdate" || name === "description" || name === "offerDiscount" || name === "offerEating"){
     setShow(false)
     setErrorMessage((old)=>{
      return{
        ...old,
       [name]:e.target.files ?imgageValidation(e):FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
  }
}

  async function postData(e){
    e.preventDefault()
    let error = Object.values(errorMessage).find((x)=>x?.length > 0)
    if(error){
      setShow(true)
     
      
    }
    else{
      let response = await fetch("http://34.228.14.188:8000/api/offer",{
        method:"GET",
        headers:{
          "content-type":"application/json"
        }
      })
      response = await response.json()
      if(response.result ==="Done"){
        setGetData(response.data)
        
        let item = Array.isArray(getData) ? getData.find((x)=> x.name.toLowerCase()===data.name.toLowerCase()  ):null
        
        if(item){
          setErrorMessage((old)=>{
            return{
              ...old,
              'name':"Name is Already Exits "
            }
          })
        }
        else{

           let formData = new FormData()
           formData.append("name", data.name)
           formData.append("pic", data.pic)
           formData.append("description", data.description)
           formData.append("validdate", data.validdate)
           formData.append("offerDiscount", data.offerDiscount)
           formData.append("offerEating", data.offerEating)

          let response = await fetch ("http://34.228.14.188:8000/api/offer",{
            method:"POST",
            body: formData
          })
          response = await response.json()
          
          if(response.result === "Done")
           {
            toast.success("Create SuccessFully !")
            navigate("/admin/offers")
           }
          else
         alert  ("something went wrong")
        }
       
      }

      else{
        // (response);
        
      }
     
    }

  }

  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>CREATE USER OFFER <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>:
                           
                       </div>
                     <form  onSubmit={postData}>
                     <div className="mb-3 mt-3 ">
                        <label for="exampleFormControlInput1"  className="form-label">Room Name*</label>
                        <input type="text" name='name' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Room Name"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Room Pic*</label>
                        <input type="file" name='pic' onChange={getInputData}  className="form-control" id="exampleFormControlInput1" />
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.pic}</p>:""}
                        
                      </div>
                      <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Discount Offer*</label>
                         <input name='offerDiscount' onChange={getInputData}  className="form-control" id="exampleFormControlinput1" rows="3" placeholder='Write the Discount offer e.g: 25% off Classic Room ....'></input>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.offerDiscount}</p>:""}
                       </div>
                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Discount Offer2 (Eating and Dining)*</label>
                         <input name='offerEating' onChange={getInputData}  className="form-control" id="exampleFormControlinput1" rows="3" placeholder='Write the About Discount Offer (e.g: Eating and Dining)....'></input>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.offerEating}</p>:""}
                       </div>
                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Offer Valid Date (e.g. 24/04/2025)*</label>
                         <input name='validdate' onChange={getInputData}  className="form-control" id="exampleFormControlinput1" rows="3" type='date'></input>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.validdate}</p>:""}
                       </div>
                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Room Description (Max- 20 Words)*</label>
                         <textarea name='description' onChange={getInputData}  className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Write the Description....'></textarea>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.description}</p>:""}
                       </div>
                       
                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>CREATE OFFER</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
